<template>
  <Popup
    v-model:show="visible"
    height="100%"
    position="bottom"
    teleport="body"
  >
    <div class="h5-currency-content">
      <div class="top-content">
        <div class="currency-content-title">
          <Icon
            @click="closeBtn"
            class="icon"
            name="icon-arrow-left-l"
          />
          <div class="middle">
            Country / Region
          </div>
          <div
            @click="handleSave"
            class="right"
          >
            Save
          </div>
        </div>
        <div
          class="search-wrapper"
        >
          <div class="search-input">
            <input
              v-model="searchQuery"
              placeholder="🔍 Search for the country or region you want."
              type="text"
            >
            <button class="search-button">
              <Icon
                class="icon"
                name="search-l"
              />
            </button>
          </div>
        </div>
      </div>
      <div
        @scroll="handleScroll"
        class="country-list"
      >
        <!-- 当前选中的国家 -->
        <div
          v-if="type === 'country'"
          class="country-item"
        >
          <div class="country-item-left">
            <img
              :src="currentCountry.countryUrl"
              alt="flag"
              class="flag"
            >
            <span>{{ currentCountry.countryName }}</span>
          </div>
          <div
            v-if="defaultChecked"
            class="country-item-right"
          >
            <img
              src="@/assets/H5/filters/check.svg"
              alt=""
            >
          </div>
        </div>
        <div
          v-for="(group, letter) in filteredList"
          :key="letter"
        >
          <div
            class="letter-header"
            :data-letter="letter"
          >
            {{ letter }}
          </div>
          <div
            @click="handleCheck(item)"
            v-for="item in group"
            :key="item.countryName"
            class="country-item"
          >
            <div class="country-item-left">
              <img
                :src="item.countryUrl"
                alt="flag"
                class="flag"
              >
              <span>{{ item.countryName }}</span>
            </div>
            <div
              v-if="item.checked"
              class="country-item-right"
            >
              <img
                src="@/assets/H5/filters/check.svg"
                alt=""
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </Popup>
</template>

<script setup>
import { ref } from 'vue'
import Icon from '@/components/Icon/Icon.vue'
import { useCountryStore } from '@/pinia/country'
import { useShipStore } from '@/pinia/ship'
import { Popup } from '@/components/Popup'

const emits = defineEmits(['save'])

const props = defineProps({
  type: {
    type: String,
    default: 'country'
  },
  currentCountry: {
    type: Object,
    default: () => ({})
  }
})

const visible = defineModel()

const country = useCountryStore()
const ship = useShipStore()

const postCode = ref('')
const searchQuery = ref('')
const defaultChecked = ref(true)

const formatCountryList = ref([])

const filteredList = computed(() => {
  const grouped = {}

  const filtered = formatCountryList.value.filter(c =>
    c.countryName.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
  filtered.forEach(item => {
    const letter = item.countryName[0].toUpperCase()
    if (!grouped[letter]) grouped[letter] = []
    grouped[letter].push(item)
  })
  return grouped
})

const handleSave = async () => {
  const item = formatCountryList.value.find(item => item.checked)
  visible.value = false
  emits('save', item)
}

const closeBtn = () => {
  visible.value = false
}

const handleCheck = (item) => {
  formatCountryList.value.forEach(item => {
    item.checked = false
  })
  item.checked = true
  defaultChecked.value = false
}

const formatData = () => {
  const letters = [...'abcdefghijklmnopqrstuvwx']
  // 先分组
  const grouped = {}
  country.list.forEach(item => {
    item.checked = false

    if (item.countryCode === props.currentCountry.countryCode) {
      item.checked = true
    }
    const l = item.countryName[0].toLowerCase()
    if (!grouped[l]) {
      grouped[l] = []
    }
    grouped[l].push(item)
  })

  // 按照字母顺序合并
  letters.forEach(letter => {
    if (grouped[letter]) {
      formatCountryList.value.push(...grouped[letter])
    }
  })

  postCode.value = ship.postCode
}

onMounted(() => {
  formatData()
})

</script>

<style lang="less" scoped>
.h5-currency-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 16px;
  overflow: hidden;
  transition: all .3s ease;
  background-color: white;

  .currency-content-title{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    font-size: 14px;
    color: #232323;
    font-family: mon-700;
    margin: 8px 0;
    .icon {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      font-size: 20px;
    }
    .right {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      font-size: 14px;
      font-family: mon-600;
      color: #052784;
    }
  }
  .search-wrapper {
    .title {
      font-size: 14px;
      font-family: mon-600;
      color: #232323;
      line-height: 20px;
    }
    .search-input {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 56px;
      margin-top: 4px;
      input {
        background-color: #f5f5f5;
        border-radius: 20px;
        padding: 0 12px;
        border: none;
        height: 40px;
        width: 100%;
        &:focus {
          outline: var(--focus-border);
        }
        &::placeholder {
          color: #b2b7c2;
          font-size: 12px;
          font-family: mon-500;
        }
      }
      .search-button {
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
        width: 44px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 16px;
        background-color: #232323;
        border: none;
        color: white;
        font-size: 20px;
      }
    }
  }
  .country-list {
    flex: 1;
    overflow: scroll;
    margin-top: 8px;
    .letter-header {
      display: flex;
      align-items: center;
      height: 36px;
      color: #232323;
      font-size: 16px;
      font-family: mon-600;
      margin-top: 8px;
    }
    .country-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 56px;
      border-bottom: 1px solid #ebf1f5;
      .country-item-left {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #232323;
        font-size: 14px;
        font-family: mon-600;
        img {
          width: 24px;
          height: 24px;
        }
      }
      .country-item-right {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        background-color: black;
        border-radius: 50%;
      }
    }
  }
}
</style>
